var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLanguage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30D1\\u30B9_13073",
    "data-name": "\\u30D1\\u30B9 13073",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10044",
    "data-name": "\\u9577\\u65B9\\u5F62 10044",
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13073-2",
    "data-name": "\\u30D1\\u30B9 13073",
    d: "M-70.478-30.923a9,9,0,0,0-9,9,9,9,0,0,0,9,9,9,9,0,0,0,9-9A9,9,0,0,0-70.478-30.923Zm-.9,16.135a7.189,7.189,0,0,1-6.3-7.136,7.3,7.3,0,0,1,.189-1.611l4.31,4.31v.9a1.8,1.8,0,0,0,1.8,1.8h0Zm6.209-2.286a1.785,1.785,0,0,0-1.71-1.251h-.9v-2.7a.9.9,0,0,0-.9-.9h-5.4v-1.8h1.8a.9.9,0,0,0,.9-.9h0v-1.8h1.8a1.8,1.8,0,0,0,1.8-1.8h0v-.369A7.183,7.183,0,0,1-63.8-19.245,7.186,7.186,0,0,1-65.169-17.074Z",
    transform: "translate(80.478 31.924)",
    fill: "#A59785"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLanguage);
export default __webpack_public_path__ + "static/media/icon_language.2828d253b4a10d35177fa4670fa95b6b.svg";
export { ForwardRef as ReactComponent };